"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var _templateObject = _taggedTemplateLiteralLoose(["\n  background: ", " !important;\n  background-color: ", " !important;\n  border: 1px solid #02adc3 !important;\n  color: white !important;\n  &:focus {\n    outline: none;\n  }\n"], ["\n  background: ", " !important;\n  background-color: ", " !important;\n  border: 1px solid #02adc3 !important;\n  color: white !important;\n  &:focus {\n    outline: none;\n  }\n"]);
function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
var styled_components_1 = __importDefault(require("styled-components"));
var semantic_ui_react_1 = require("semantic-ui-react");
exports.Button = styled_components_1.default(semantic_ui_react_1.Button)(_templateObject, function (props) {
    return props.alt ? "#262936" : "#02adc3";
}, function (props) {
    return props.background;
});
//# sourceMappingURL=Button.js.map